import BaseTable from 'components/Tables/BaseTable';
import { actions as scenariosDescriptorsConditionsActions } from 'ducks/scenariosDescriptorsConditions';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData, lookUpIdValueSelector } from 'selectors/generic';
import arrayToObject from 'utils/arrayToObject';
import columns from 'utils/tables/columns/scenarioConditions';
import { currentUser } from 'selectors/currentUser';

const Component = props => {
  const {
    conditionsFilter, conditionsById, descriptors, scenarioDescriptor,
    units, user
  } = props;
  const { conditions, scenarioDescriptorConditions } = props;
  const { closeConditions, create, remove, update } = props;
  const tableRef = React.useRef(null);

  const filteredConditions = conditions.filter(v => v.type === conditionsFilter);

  const filteredSDC = scenarioDescriptorConditions.filter(sdc =>
    sdc.scenario_descriptor_id === scenarioDescriptor.id
  );

  const [selectedIds, setSelectedIds] = useState(filteredSDC.map(fsdc => fsdc.condition_id));
  const [loading, setLoading] = useState(false);

  useEffect(
    () => setSelectedIds(filteredSDC.map(fsdc => fsdc.condition_id)),
    [scenarioDescriptorConditions]
  );

  // TODO Adding Checked info to table, there should be a better way
  const fsdcByConditionId = arrayToObject(filteredSDC, 'condition_id');
  const rows = filteredConditions.map(element => {
    const baseElement = { ...element, value: '' };
    // TODO fsdcByConditionId[element.id] condition has this because the state suffers
    // TODO update on useEffect and not with action, should be corrected
    if (selectedIds.includes(element.id) && fsdcByConditionId[element.id]) {
      const valor = fsdcByConditionId[element.id].value;
      const unit_id = fsdcByConditionId[element.id].unit_id;
      return {
        ...baseElement,
        tableData: { checked: true },
        valor,
        unit_id
      };
    } else {
      return { ...baseElement, tableData: { checked: false } };
    }
  });

  const reOrderedRows = sortBy(rows, [row => !selectedIds.includes(row.id), 'id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={closeConditions}
        title={`CONDIÇÕES - ${descriptors[scenarioDescriptor.descriptor_id].code}`}
        columns={columns(user, units)}
        data={reOrderedRows}
        order={false}
        onRowClick={() => null}
        paging={false}
        options={{
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          selectionProps: rowData => ({
            //checked: prevInterSubstanceIds.includes(rowData.id)
            //onClick: (event , rowData) => this.handleCheckboxClick(event,rowData),
          })
        }}
        isLoading={loading}
        editable={{
          onRowUpdate: (newData, oldData) => {
            if (oldData.tableData.checked) {
              const id_sdc = filteredSDC.find(fsdc => fsdc.condition_id === newData.id).id;
              return update(
                id_sdc,
                {
                  ...newData,
                  unit_id: newData.unit_id === '' ? null : newData.unit_id
                }
              );
            } else {
              return create({
                scenario_descriptor_id: scenarioDescriptor.id,
                condition_id: newData.id,
                ...newData,
                unit_id: newData.unit_id === '' ? null : newData.unit_id
              });
            }
          }
        }}
        onSelectionChange={(rows, difRow) => {
          setLoading(true);
          if (rows.length > selectedIds.length) {
            create({
              scenario_descriptor_id: scenarioDescriptor.id,
              condition_id: difRow.id,
              unit_id: conditionsById[difRow.id].unit_id
            })
              .then(() => setLoading(false))
              .catch(e => alert(e));
          } else {
            const id_sdc = filteredSDC.find(fsdc => fsdc.condition_id === difRow.id).id;
            remove(id_sdc)
              .then(() => setLoading(false))
              .catch(e => alert(e));
          }
        }}
      />
    </React.Fragment>
  );
};

const makemapStateToProps = () => {
  const conditions = getImmutableStoreData('conditions');
  const units = lookUpIdValueSelector('units', ['name']);
  const mapStateToProps = (state, props) => ({
    conditions: conditions(state),
    conditionsById: state.conditions.models,
    descriptors: state.descriptors.models,
    scenarioDescriptorConditions: state.scenarioDescriptorConditions.data,
    units: units(state),
    user: currentUser(state),
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  create: data => dispatch(scenariosDescriptorsConditionsActions.createPromise(data)),
  update: (id, data) => dispatch(scenariosDescriptorsConditionsActions.updatePromise(id, data)),
  remove: id => dispatch(scenariosDescriptorsConditionsActions.removePromise(id))
});

export default connect(makemapStateToProps, mapDispatchToProps)(Component);
